import { render, staticRenderFns } from "./checkingTable.vue?vue&type=template&id=31cf6d52&scoped=true&"
import script from "./checkingTable.vue?vue&type=script&lang=js&"
export * from "./checkingTable.vue?vue&type=script&lang=js&"
import style0 from "./checkingTable.vue?vue&type=style&index=0&lang=less&"
import style1 from "./checkingTable.vue?vue&type=style&index=1&id=31cf6d52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cf6d52",
  null
  
)

export default component.exports